import { useSuspenseQuery } from '@tanstack/react-query'

import { GetLotesEmpreendimentoService } from '@/features/produtos/services/get-lotes-empreendimento.service'
import { produtosKeys } from '@/features/produtos/utils/queries'

export const useSuspenseLotesEmpreendimento = (idExternoEmpreendimento: string) => {
  return useSuspenseQuery({
    queryKey: produtosKeys.lotesEmpreendimento(idExternoEmpreendimento),
    queryFn: () =>
      new GetLotesEmpreendimentoService().execute(idExternoEmpreendimento).then((response) => response.data),
  })
}
